meedy.factory('meedy.deviceModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.deviceService',
    function($rootScope, applicationModel, baseModel, deviceService) {

        function DeviceModel() {

            this.getActiveDevices = function(criteria) {
                deviceService.getActiveDevices(criteria).then(
                    function (dataPage) {
                        $rootScope.$broadcast(Event.MEEDY.DEVICE.GET_ACTIVE_DEVICES.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.DEVICE.GET_ACTIVE_DEVICES.ERROR, error);
                    }
                )
            };

            this.deleteActiveDevice = function(userName) {
                deviceService.deleteActiveDevice(userName).then(
                    function (dataPage) {
                        baseModel.broadcastOperationSucceeded();
                        $rootScope.$broadcast(Event.MEEDY.DEVICE.DELETE_ACTIVE_DEVICE.SUCCESS, dataPage);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.DEVICE.DELETE_ACTIVE_DEVICE.ERROR, error);
                    }
                )
            };

        }

        return new DeviceModel();
    }
]);
